module.exports = __webpack_public_path__ + "img/vue2-toebox_blanc.8ba734a8.png";